export default __webpack_public_path__ + "static/media/Disney.c788296b.png";